import { getLocale } from "../runtime";

const sv_anerroroccurred = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ett fel inträffade`
};

const anerroroccurred = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_anerroroccurred(inputs)
	return "anErrorOccurred";
};

export { anerroroccurred as "anErrorOccurred" };